import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { OrderTransport } from "src/app/transports/order";
import { Order } from "src/app/types/orders/order";
import { Site } from "src/app/types/Site";

export interface IuseRDSubmitHandler {
    updateGridOnSave(object: any, isNew: boolean, removeRow?: boolean | undefined): void;
    handleClose(): void;
}

const useRDSubmitHandler = (params: IuseRDSubmitHandler) => {
    const { updateGridOnSave, handleClose } = params;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();

    const submit = async (selectedRows: Array<Site>, entity: Order) => {
        if (!selectedRows[0]?.id) {
            toast.error(formatMessage({ id: "common.notification.error" }));
            return;
        }
        const currentOrder = {
            ...OrderTransport.formTransformer(entity),
            rdId: selectedRows[0]?.id,
        };
        setLoading(true);
        try {
            const res = await OrderTransport.addRD(currentOrder, entity?.id);
            await updateGridOnSave(res, false, true);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };
    return { submit, loading };
};

export default useRDSubmitHandler;
